<template>
  <div>
    <div class="row justify-content-center">
      <div class="col text-center">
        <h3 v-if="survey.surveyName">{{ survey.surveyName }}</h3>
        <h3 v-else>{{ title }}</h3>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <card class="card-register card-white">
          <template slot="header">
            <div class="d-none d-md-block">
              <img class="card-img" :src="`img/${cardBackground}`" alt="Message Background" />
              <h4 class="card-title">{{ type }}</h4>
            </div>
          </template>
          <div class="row">
            <div class="col-md-10 col-lg-8 ml-auto mr-auto">
              <div class="alert alert-info text-center">
                <div v-if="type === 'completed'">
                  <span v-html="completedMsg"></span>
                </div>
                <div v-else-if="type === 'not started'">
                  <div>The survey you're requesting has not yet started.</div>
                  <div class="mt-3"><b>Please contact your survey administrator for details.</b></div>
                </div>
                <div v-else-if="type === 'ended'">
                  <div><b>The survey you're requesting has ended.</b></div>
                  <div class="mt-3"><b>Please contact your survey administrator for details.</b></div>
                </div>
                <div v-else>
                  <div>Welcome to the HSP, a secure survey platform brought to you by HRTec, Inc.</div>
                  <div class="mt-3">If you are a survey administrator, please contact your HRTec representative for access to the system.</div>
                  <div class="mt-3">If you are looking for survey access, please get the survey url from your survey administrator.</div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Welcome',
  props: {
    type: {
      type: String,
      default: 'welcome'
    },
    surveyId: {
      type: String
    },
    title: {
      type: String,
      default: 'HRTec Survey Platform (HSP)'
    },
    completedMsg: {
      type: String,
      default: 'Thank you for participating in our online survey!'
    }
  },
  computed: {
    cardBackground() {
      if (this.colorScheme !== 'primary') {
        return this.$store.state.themes[this.colorScheme].loginImage;
      }

      return 'card-primary.png';
    },
    colorScheme() {
      return this.$store.getters.themeColor(this.surveyId) || 'primary';
    },
    survey() {
      return this.$store.getters.getOrgSurveyByUrlId(this.surveyId) || {};
    }
  }
};
</script>
<style scoped>
.card-register .card-header .card-title {
  font-size: 4.5em;
}
</style>
